import { Injectable } from '@angular/core';
import { Versions } from '../enums';
import { TreatmentInfoAnswer, TreatmentInfoQuestion, TreatmentInfoSection } from '../models';

@Injectable()
export class TreatmentDetailsHelper {
  mapInfo(treatmentInfo: TreatmentInfoSection[], version: Versions = Versions.One, initOrder: number = 0) {
    let order = initOrder ?? 0;
    return treatmentInfo.map(s => {
      const section = Object.assign(new TreatmentInfoSection(), s);

      section.questions = this.mapQuestions(section.questions, version, order);

      return section;
    });
  }

  mapQuestions(
    questions: TreatmentInfoQuestion[],
    version: Versions = Versions.One,
    order: number
  ): TreatmentInfoQuestion[] {
    return questions
      .filter(x => version & x.version)
      .map(q => {
        let question = Object.assign(new TreatmentInfoQuestion(), q);

        question.order = ++order;

        const parsed = Number(q.value);
        question.value = q.value !== null && isFinite(parsed) ? parsed : q.value;
        question.answers = this.mapAnswers(question.answers);

        question.answers.forEach(a => {
          a.questions = this.mapQuestions(a.questions, version, order);

          if (a.questions && a.questions.length > 0) {
            order = Math.max(...a.questions.map(o => o.order));
          }
        });

        return question;
      });
  }

  mapAnswers(answers: TreatmentInfoAnswer[]): TreatmentInfoAnswer[] {
    return answers.map(a => {
      let answer = Object.assign(new TreatmentInfoAnswer(), a);

      answer.id = Number(a.id);

      return answer;
    });
  }
}
